import React from "react";
import { connect } from "react-redux";
import Tooltip from "@/src/components/common/Elements/Tooltip/Tooltip";

import Axios from "Source/axiosPool";
import Select from "Components/common/Select/Select";
import Avatar from "Components/common/Avatar/Avatar";

@connect(store => {
    return {
        conversations: store.conversations,
        loggedUser: store.loggedUser,

    };
})

class Recipient extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            members: [],

        };
        
        _.map(
            ["membersList"],
            fn => {
                this[fn] = this[fn].bind(this);
            }
        );
    }

    membersList(options = null) {
        const { projectId, loggedUser } = this.props;
        const fetchUrl = `/api/projects/${projectId}/members`;

        Axios.get(fetchUrl).then(c => {
            if (c) {
                const taskMemberOptions = _(c.data)
                    .map(u => ({
                        value: u.user.id,
                        label: `${u.user['first-name']} ${u.user['last-name']}`,
                        avatar: u.user.avatar,
                        id: u.user.id,
                        type: u.user['user-type'],
                        firstName: u.user['first-name'],
                        lastName: u.user['last-name'],
                        emailAddress: u.user.email,
                        position: u.position,
                        user_role: u.user.role || "Member",
                        title: u.title,
                        isProjectLead: u['is-project-lead'] || false
                    }))
                    .value();
                const members = taskMemberOptions.filter(f => f.value !== loggedUser.data.id);
                this.setState({ ...this.state, members });
            }
        });
    }

    render() {
        const { conversations, dispatch } = this.props;

        const handleSelectMembers = (value, action) => {
            if( action === "all") {
                dispatch({ type: "UPDATE_CONVERSATIONS_FIELD", field: "to", value });
            } else {
                dispatch({ type: "UPDATE_CONVERSATIONS_FIELD", field: "to", value: action !== "removed" ? [...conversations.fields.to, value] : conversations.fields.to.filter( c => c.value !== value.value ) });
            }
        }

        const handleRenderOption = value => {
            let userRole = "";
            if (Array.isArray(value.user_role) && value.user_role.length > 0 && value.user_role[0] && value.user_role[0].role) {
                const role = value.user_role[0].role;
                userRole = `${role.roleType} ${role.role}`;
            } else if (typeof value.user_role === "object" && value.user_role && value.user_role.role) {
                userRole = `${value.user_role.roleType || ""} ${value.user_role.role || ""}`;
            } else if (typeof value.user_role === "string") {
                userRole = value.user_role;
            } else {
                userRole = "Member";
            }

            return (
                <div class="userOption">
                    <Avatar id={`optionUsers_${value.value}`} disableTooltip={true} name={`${value.label}`} image={value.avatar !== "default.png" ? `/api/file/profile_pictures/${value.avatar}` : null} />
                    <div class="recipientOptionContainer">
                        <span>{value.label}</span>
                        <span>{userRole}</span>
                    </div>
                </div>
            );
        }

        const handleRenderSelected = value => {
            const handleRemove = (user) => {
                dispatch({ type: "UPDATE_CONVERSATIONS_FIELD", field: "to", value: conversations.fields.to.filter( c => c.value !== user.value ) });
            };

            return (
                <div class="selectedItemsContainer" >
                    { value.filter((f,i)=>i < 5).map(value =>
                        <React.Fragment>
                            <div>
                                <Avatar id={`selectedUsers_${value.value}`}  disableTooltip={true} name={`${value.label}`} image={value.avatar !== "default.png" ? `/api/file/profile_pictures/${value.avatar}` : null} />
                                <span>{value.label.length>11?value.label.substring(0,9)+"...":value.label}</span>
                                <a class="clearIcon" onClick={ () => handleRemove(value) }><i class="material-icons">cancel</i></a>
                            </div>
                        </React.Fragment>  
                    )}
                    { value.length > 5 && 
                        <React.Fragment>
                            <div>
                                <span   data-tooltip-id={`tooltip_selected_notes_members`} style={{ lineHeight: "15px"}}>+{value.length - 5} </span>

                                <Tooltip id={`tooltip_selected_notes_members`}  place="bottom" effect="solid" >
                                    {value.filter((f,i)=>i >= 5).map(s=>
                                        {
                                            return(
                                                <div>{s.label}</div>
                                            )
                                        }
                                    )}
                                </Tooltip>
                            </div>
                        </React.Fragment>
                    }
                </div>
            );
        }

        return (
            <div class="formContainer">
                <label>To: <sup>*</sup></label>
                <Select 
                    includeSelectAll={true}
                    selectAllLabel={'All Members'}
                    isMultiple={true}
                    isSearchable={true}
                    classes={{options: `recipientOptions`}}
                    options={ this.state.members }
                    placeholder="Select"
                    onChange={ handleSelectMembers }
                    onOpen={ this.membersList }
                    renderOption={ handleRenderOption }
                    selected={ conversations.fields.to }
                    renderCustomSelected={ handleRenderSelected }
                    searchIcon={<i class="material-icons">search</i>}
                    isClose={ conversations.actionType === "formSubmit" }
                />
            </div>
        );
    }
}

export default Recipient;